export class SuccessErrorData {
  success: any;
  error: any;
}
